import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import '../assets/css/pages/pageContainer.css'
import { ArrowDown01Icon, ArrowLeft01Icon, ArrowRight01Icon, Link01Icon, Menu01Icon } from 'hugeicons-react'
import { qControlFeatures } from '../constants/q-control'
import { kpiFeatures } from '../constants/kpi'

function PageContainer({ content }) {
    const [features, setFeatures] = useState([])
    const [docTitle, setDocTitle] = useState('')
    const [homeUrl, setHomeUrl] = useState('')
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

    const handleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen)
    }

    useEffect(() => {
        const activeProject = localStorage.getItem('activeProject') || 'q-control'
        setFeatures(activeProject === 'q-control' ? qControlFeatures : kpiFeatures)
        setDocTitle(activeProject === 'q-control' ? 'Quality Control' : 'KPI Tool')
        setHomeUrl(activeProject === 'q-control' ? 'https://q-control.csrlimited.com/' : 'https://kpi.csrlimited.com/')
    }, [])
    return (
        <div className='page-container'>
            <header className='container'>
                <div onClick={handleMobileMenu} className="mobile-menu">
                    {
                        !mobileMenuOpen &&
                        <ArrowLeft01Icon className='arrow-right' />
                    }
                    <Menu01Icon />
                    {
                        mobileMenuOpen &&
                        <ArrowRight01Icon className='arrow-right' />
                    }
                </div>
                <Link to={'/'} className="branding">
                    <h1>CHMC Doc<span>umentation</span></h1>
                    <p>Cohesive healthcare management and consulting</p>
                </Link>
                <Link to={homeUrl} className="button primary-button support-link">
                    Login <span>{docTitle}</span>
                    <Link01Icon />
                </Link>
            </header>
            <div className={`content-container container`}>
                <SideBar docTitle={docTitle} features={features} mobileMenuOpen={mobileMenuOpen} />
                <div className="content">
                    {content}
                </div>
            </div>
            <footer></footer>
        </div>
    )
}

export default PageContainer


const Feature = ({ activeFeature, activeLink, handleFeatureClick, featureName, links, handleLinkClick, link }) => {
    return (
        <div className={`feature ${activeFeature === featureName ? 'feature-open' : 'feature'}`}>
            <div onClick={() => handleFeatureClick(featureName)} className="feature-title"><span>{featureName}</span> <ArrowRight01Icon className={` ${activeFeature === featureName ? 'rotate' : 'un-rotate'}`} /> </div>
            <div className="feature-elements">
                {
                    links && links.map((link, index) => (

                        <Link to={link.link} key={index} onClick={() => handleLinkClick(link.name)} className={`element ${activeLink === link.name ? 'active' : ''}`}>
                            <div className="dot"></div>
                            <span>{link.name}</span>
                        </Link>
                    ))
                }

            </div>
        </div>

    )
}

const SideBar = ({ docTitle, features, mobileMenuOpen }) => {
    const navigate = useNavigate()
    const [activeFeature, setActiveFeature] = useState(null)
    const [activeLink, setActiveLink] = useState('')

    const handleFeatureClick = (feature) => {
        setActiveFeature(activeFeature === feature ? '' : feature)
        localStorage.setItem('activeFeature', feature)
    }

    const handleLinkClick = (link) => {
        setActiveLink(activeLink === link ? '' : link)
        localStorage.setItem('activeLink', link)

    }
    useEffect(() => {
        const activeFeatureFromStorage = localStorage.getItem('activeFeature')
        const activeLinkFromStorage = localStorage.getItem('activeLink')
        setActiveFeature(activeFeatureFromStorage || 'Introduction')
        setActiveLink(activeLinkFromStorage || 'What is Q-control')

    }, [])

    return (
        <nav className={`side-bar ${mobileMenuOpen ? 'open' : ''}`}>
            <h2 className="doc-title">{docTitle}</h2>
            {
                features && features.map((feature) => (

                    <Feature
                        activeFeature={activeFeature}
                        activeLink={activeLink}
                        handleFeatureClick={handleFeatureClick}
                        handleLinkClick={handleLinkClick}
                        featureName={feature.featureName}
                        links={feature.links}
                    />
                ))
            }
            {/* <Feature
                activeFeature={activeFeature}
                activeLink={activeLink}
                handleFeatureClick={handleFeatureClick}
                handleLinkClick={handleLinkClick}
                featureName={'Authentication'}
                links={[
                    { "name": "Login", link: 'login' },
                    { "name": "Forgot password", link: 'forgot-pass' },
                ]} />

            <Feature
                activeFeature={activeFeature}
                activeLink={activeLink}
                handleFeatureClick={handleFeatureClick}
                handleLinkClick={handleLinkClick}
                featureName={'Profile'}
                links={[
                    { "name": "Incident reports", link: 'incident-reports' },
                    { "name": "Drafts", link: 'drafts' },
                    { "name": "Documents", link: 'documents' },
                    { "name": "Support tickets", link: 'support-tickets' },
                    { "name": "Edit profile", link: 'edit-profile' },
                    { "name": "Change password", link: 'change-password' },
                ]} />


            <Feature
                activeFeature={activeFeature}
                activeLink={activeLink}
                handleFeatureClick={handleFeatureClick}
                handleLinkClick={handleLinkClick}
                featureName={'Incident tracking'}
                links={[
                    { "name": "New incident", link: 'new-incident' },
                    { "name": "Modify incident", link: 'modify-incident' },
                    { "name": "Drafts", link: 'drafts' },
                    { "name": "Send to department", link: 'send-to-department' },
                    { "name": "Mark resolved", link: 'mark-resolved' },
                    { "name": "Delete incident", link: 'delete-incident' },
                ]}
            />


            <Feature
                activeFeature={activeFeature}
                activeLink={activeLink}
                handleFeatureClick={handleFeatureClick}
                handleLinkClick={handleLinkClick}
                featureName={'Complaint'}
                links={[
                    { "name": "New complaint", link: 'new-complaint' },
                    { "name": "Modify complaint", link: 'modify-complaint' },
                    { "name": "Send to department", link: 'send-to-department' },
                    { "name": "Mark resolved", link: 'mark-resolved' },
                    { "name": "Delete complaint", link: 'delete-complaint' },
                ]}
            />
            <Feature
                activeFeature={activeFeature}
                activeLink={activeLink}
                handleFeatureClick={handleFeatureClick}
                handleLinkClick={handleLinkClick}
                featureName={'Documents'}
                links={[
                    { "name": "New document", link: 'new-document' },
                    { "name": "Delete document", link: 'delete-document' },
                ]}
            />

            <Feature
                activeFeature={activeFeature}
                activeLink={activeLink}
                handleFeatureClick={handleFeatureClick}
                handleLinkClick={handleLinkClick}
                featureName={'Support tickets'}
                links={[
                    { "name": "New ticket", link: 'new-ticket' },
                    { "name": "Modify ticket", link: 'modify-ticket' },
                    { "name": "Delete ticket", link: 'delete-ticket' },
                    { "name": "Reopen ticket", link: 'reopen-ticket' },
                    { "name": "Close ticket", link: 'close-ticket' },
                ]}
            /> */}

        </nav>
    )
}


